import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';

import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { Breadcrumb, Button, Card, Col, Container, Form, Row, Table } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import { useFieldArray, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import DeleteModal from '../../../Common/modals/DeleteModal';
import FormProvider from '../../../FunctionalComponent/FormElement/FormProvider';
import { useGetActiveColorMutation } from '../../../Redux/ColorSlice';
import {
  getProductInfos,
  setProductCurrentStep,
  setProductInfo,
  useCreateProductStepTwoMutation,
} from '../../../Redux/ProductSlice';
import { useGetActivesizeMutation } from '../../../Redux/SizeSlice';
import { useUplaodFileMutation } from '../../../Redux/file/fileApi';

// const stepOneSchema = Yup.object().shape({
//     // name: Yup
//     //     .string()
//     //     .required()
//     //     .strict(true)
//     //     .trim('White spaces before and after are not allow'),
//     // slug: Yup.string().matches(/^\S+$/, 'String should contain at least one non-space character'),
//     // isActive: Yup.string().required('Status is required'),
//     // sortDescription: Yup
//     //     .string()
//     //     .required()
//     //     .strict(true),

//     // longDescription: Yup
//     //     .string()
//     //     .required()
//     //     .strict(true),
//     MRP: Yup.number().typeError('Input must be a valid number').positive('Input must be a positive number').required('Input is required'),
//     sellingPrice: Yup.number().typeError('Input must be a valid number').positive('Input must be a positive number').required('Input is required'),

// });

const validateWith = {
  shouldDirty: true,
  shouldTouch: true,
  shouldValidate: true,
};

let selectColorId = null;

const StepTwoProduct = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getProducInfo = useSelector(getProductInfos);

  const {
    productUniqueCode: defaultDataSku,
    MRP: defaultDataMRP,
    sellingPrice: defaultDatasellingPrice,
  } = getProducInfo;
  const productId = getProducInfo?.productId;

  const [fileUploadFn, { data: fileData, isSuccess: fileSuccess, error: fileError }] =
    useUplaodFileMutation();

  const [getActiveColorFn, { data: activeColors, isLoading: colorLoading }] =
    useGetActiveColorMutation();
  const [getActiveSizeFn, { data: activeSizes, isLoading: sizeLoading }] =
    useGetActivesizeMutation();
  const [createProductFn, { data, isSuccess, error, isLoading }] =
    useCreateProductStepTwoMutation();
  const [isExit, setIsExit] = useState(false);
  const { pathname } = useLocation();
  // const [isExit, setIsExit] = useState(false)

  useEffect(() => {
    getActiveColorFn();
    getActiveSizeFn();
  }, []);

  const defaultValues = {
    productId: productId,
    sizes: [],
    colours: [],
    productImageColourData: [],
    productSizeColourData: [],
    sizesShowData: [],
    colorsShowData: [],
    isDefault: '',
    defaultImageUrl: '',
    productBannerImage: '',
  };
  // const schema = Yup.object().shape({
  //   productSizeColourData: Yup.array().of(
  //     Yup.object().shape({
  //       MRP: Yup.number().required('MRP is required'),
  //       sellingPrice: Yup.number().lessThan(Yup.ref('MRP'), 'Selling price must be less than MRP'),
  //       quantity: Yup.number()
  //         .min(0, 'Quantity must be Positive Number'),
  //       maxOrderQuantity: Yup.number()
  //         .min(0, 'Max order quantity must be Positive Number'),
  //     }),
  //   ),

  // });
  const schema = Yup.object().shape({
    productSizeColourData: Yup.array().of(
      Yup.object().shape({

        MRP: Yup.number().required('MRP is required').min(0, 'MRP must be Positive Number'),
        sellingPrice: Yup.number().lessThan(Yup.ref('MRP'), 'Selling price must be less than MRP').min(0, 'Selling price must be Positive Number'),
        quantity: Yup.number()
          .typeError('Quantity must be a number')
          .min(0, 'Quantity must be a positive number')
          .nullable(true), // Adjust this as needed
        maxOrderQuantity: Yup.number()
          .typeError('Max order quantity must be a number')
          .min(0, 'Max order quantity must be a positive number')
          .nullable(true), // Adjust this as needed
      }).test('mrpGreaterThanSellingPrice', 'MRP must be greater than or equal to selling price', function (value) {
        const { MRP, sellingPrice } = this.parent;
        if (MRP && sellingPrice && MRP < sellingPrice) {
          return false;
        }
        return true;
      }),
    ),
  });



  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: 'all',
  });

  const {
    reset,
    register,
    setError,
    setValue,
    handleSubmit,
    watch,
    getValues,
    control,
    formState: { errors },
  } = methods;


  const { fields, append, remove } = useFieldArray({
    control,
    name: 'productSizeColourData',
  });

  // useEffect(() => {
  //   if (Object.keys(errors).length != 0) {
  //     const errorData = errors;
  //     toast.error(errorData.productSizeColourData?.[0]?.sellingPrice?.message);
  //   }
  // }, [errors]);
  useEffect(() => {
    if (Object.keys(errors).length !== 0) {
      errors.productSizeColourData?.forEach((item, index) => {
        if (item && item.sellingPrice) {
          toast.error(item.sellingPrice.message);
        }
        if (item && item.quantity) {
          toast.error(item.quantity.message);
        }
        if (item && item.maxOrderQuantity) {
          toast.error(item.maxOrderQuantity.message);
        }
      });
    }
  }, [errors]);

  const onSubmit = async (data) => {
    let imgErr = false;

    try {
      const {
        colorsShowData,
        productSizeColourData,
        productImageColourData,
        sizesShowData,
        isDefault,
        ...rest
      } = data;
      // return;

      const productSizeColourDatas = productSizeColourData?.map((it) => ({
        ...it,
        productColourId: it?.productColourId?.value,
        sizeId: it?.sizeId?.value,
      }));

      const productImageColourDatass = productImageColourData?.map((it) => {
        if (!it?.image?.length) {
          imgErr = true;
          toast.error(`Please choose an image for ${it?.productColourId?.label}`);

        }


        const formatteData = {
          image: it?.image,
          productColourId: it?.productColourId?.value,
          isDefault: false,
        };
        if (it?.productColourId?.value == isDefault) {
          formatteData.isDefault = true;
        }
        return formatteData;
      });

      if (rest?.productBannerImage == null) {
        imgErr = true;
        toast.error(`Please choose an product banner image`);
      }
      const sendData = {
        ...rest,
        productSizeColourData: productSizeColourDatas,
        productImageColourData: productImageColourDatass,
        sizes: data?.sizes?.map((it) => it.value),
        colours: data?.colours?.map((it) => it.value),
        productListImage: getValues('productListImage'),
      };



      if (!imgErr) {
        createProductFn(sendData);

        dispatch(setProductInfo({ ...data }));
      }

      // const promiseAll = await Promise.all([
      //     // uploadFile(categoryImage),
      //     // uploadFile(icon),
      //     // uploadFile(banner),
      // ]);

      // createCategoryFn({
      //     ...data, categoryImage: promiseAll[0],
      //     icon: promiseAll[1],
      //     banner: promiseAll[2],
      // })

      // setcategoryImage(null)
      // seticon(null)
      // setbanner(null)
    } catch (error) {
      setError('afterSubmit', {
        ...error,
        message: error.message,
      });
    }
  };

  const handleFileChange = (e, setFile, name) => {
    const file = e.target.files?.[0];
    const fileName = e.target.name;

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (reader.readyState === 2) {
          setValue(fileName, reader.result, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          });
        }
      };
      reader.readAsDataURL(file);
      setFile(file);
    }
  };

  useEffect(() => {
    if (fileSuccess) {
      const message = fileData?.message || 'File upload successful';
      // toast.success(message);
      // setProductStep('STEP3')
      // dispatch(setProductCurrentStep('STEP3'))
    }
    if (fileError) {
      if ('data' in fileError) {
        const errorData = fileError;
        toast.error(errorData.data.message);
      }
    }
  }, [fileData, fileSuccess, fileError]);

  const [selectedFiles, setselectedFiles] = useState([]);

  const uploadFile = async (file) => {
    if (!file) {
      // If there's no file to upload, resolve immediately
      return;
    }

    try {
      const formData = new FormData();
      formData.append('image', file);
      const response = await fileUploadFn(formData);
      return response?.data?.response?.url;
    } catch (error) {
      throw error;
    }
  };


  let loadingToastId; // Variable to store the loading toast ID

  async function handleAcceptedFiles(files, colorItem) {

    const maxFileSize = 10 * 1024 * 1024; // 10 MB in bytes
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

    // Show loading message
    loadingToastId = toast.loading('File is uploading....');

    const invalidFiles = files.filter(file => {
      if (file.size > maxFileSize) {
        toast.error(`File ${file.name} exceeds 10MB limit.`);
        toast.dismiss(loadingToastId);
        return true;
      }
      // Check file type
      if (!allowedTypes.includes(file.type)) {
        toast.error(`Invalid file type. Please upload a JPG, JPEG, PNG, or WEBP file: ${file.name}`);
        toast.dismiss(loadingToastId);
        return true;
      }
      return false;
    });
    if (invalidFiles.length > 0) {
      // Hide loading message
      toast.dismiss(loadingToastId);
      return;
    }

    files.map((file) =>
      Object.assign(file, {
        // preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );

    const promiseAll = await Promise.all(files.map((it) => uploadFile(it)));
    let selectedFilesUrls = selectedFiles;

    promiseAll?.filter(Boolean).map((url) => {
      selectedFilesUrls = [
        ...selectedFilesUrls,
        {
          preview: url,
          productColourId: colorItem?.value,
        },
      ];
      setselectedFiles(selectedFilesUrls);

      const updateImages = getValues('productImageColourData').map((it) =>
        it?.productColourId?.value === colorItem?.value
          ? { ...it, image: [...it?.image, { preview: url, productColourId: colorItem?.value }] }
          : it,
      );
      setValue('productImageColourData', updateImages);
    });

    // Do something else
    if (!getValues('defaultImageUrl')) {
      setValue('defaultImageUrl', selectedFilesUrls?.[0]?.preview);
    }

    // Hide loading message
    toast.update(loadingToastId, {
      render: 'File uploaded successfully',
      type: 'success',
      isLoading: false,
      autoClose: true,
      closeButton: true,
    });
  }


  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  useEffect(() => {
    if (productId) {
      // const productColors = getProducInfo?.ProductColourCombinations?.map(it => it?.productColourId);
      // const productSizses = getProducInfo?.ProductSizeCombinations?.map(it => it?.sizeId);
      // if (productColors?.length > 0 && productSizses?.length > 0) {

      // }
      if (getProducInfo?.sizes?.length > 0 && getProducInfo?.colours?.length > 0) {
        setShowVarient(true);
      }

      for (const key in defaultValues) {
        if (Object.hasOwnProperty.call(defaultValues, key)) {
          setValue(key, getProducInfo?.[key], validateWith);
        }
      }
      setValue(
        'productBannerImage',
        getProducInfo?.productListImageViews?.[0]?.productBannerImage,
        validateWith,
      );

      let arr = [];

      getProducInfo?.productImageColourData?.forEach((element, index) => {
        arr = [...arr, ...element?.image];
      });
      setselectedFiles(arr);

      setValue('defaultImageUrl', arr[0]?.preview);

      setValue('productListImage', getProducInfo?.productListImageViews?.[0]?.productListImage);

      const isDefaultSet = getProducInfo?.ProductImageColourCombinations?.find(
        (it) => it?.isDefault?.toString() == 'true',
      )?.productColourId;
      setValue(
        'isDefault',
        isDefaultSet ?? getProducInfo?.ProductImageColourCombinations?.[0]?.productColourId,
      );
    }
  }, [productId]);

  const handleDeleteSizeColor = (colorItems, sizeId) => {
    const filterProductSizeColourData = getValues('productSizeColourData').filter((it) => {
      if (it.productColourId?.value !== colorItems?.value) {
        return true;
      }
      if (it.sizeId?.value !== sizeId?.value) {
        return true;
      }
      return false;
    });
    setValue('productSizeColourData', filterProductSizeColourData);
  };

  const [showVarient, setShowVarient] = useState(false);
  const findIndexForChangeEvent = (colorItems, sizeId) =>
    getValues('productSizeColourData').findIndex(
      (item) =>
        item.productColourId?.value === colorItems?.value && item.sizeId?.value === sizeId?.value,
    );
  function getAbbreviation(input) {
    // Split the input string by space
    const words = input.split(" ");
    let abbreviation = "";

    if (words.length === 1) {

      const firstLetter = input?.[0];
      const lastLetter = input?.[input?.length - 1];
      abbreviation = `${firstLetter}${lastLetter}`
      return abbreviation.toUpperCase();
    } else {
      for (let i = 0; i < words.length; i++) {
        if (words[i].length > 0) {
          abbreviation += words[i][0];
        }
      }

      return abbreviation.toUpperCase();

    }

  }


  function generateProductSizeColourData(
    sizes,
    colours,
    otherData,
    // productId,
    // skuId,
    // quantity,
    // MRP,
    // sellingPrice,
    // offer
  ) {
    const productSizeColourData = [];

    for (const sizeId of sizes) {
      for (const productColourId of colours) {

        productSizeColourData.push({
          sizeId,
          productColourId,
          ...otherData,
          skuId: `KH-TS${otherData?.skuId}-${getAbbreviation(productColourId?.label)}-${sizeId?.label}`,
        });
      }
    }
    if (!getValues('isDefault')) {
      setValue('isDefault', colours?.[0]?.id);
    }



    return productSizeColourData;
  }

  const filterSizeVarients = (colorId) =>
    getValues('productSizeColourData')?.filter((it) => {
      return it?.productColourId?.value === colorId?.value;
    });

  const colorName = (colorId) => {
    const name = activeColors?.response?.find((it) => it?.id === colorId.value);
    return name;
  };
  const sizeName = (sizeId) => {
    const size = activeSizes?.response?.find((it) => it?.id === sizeId.value);
    return size;
  };
  const yy = watch();

  useEffect(() => {
    if (isSuccess) {
      const message = data?.message || 'Product created successfully';
      toast.success(message);
      // dispatch(setProductInfo({ ...getValues(), productId: data?.response }))

      if (!isExit) {
        dispatch(setProductCurrentStep('STEP4'));
      } else {
        navigate('/products-list');
      }
    }
    if (error) {
      if ('data' in error) {
        const errorData = error;
        toast.error(errorData.data.message);
      }
    }
  }, [data, isSuccess, error]);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    selectColorId = null;
    setShow(false);
  };
  const handleShow = (colorItem) => {
    selectColorId = colorItem;
    setShow(true);
  };

  const [draggingSingle, setDraggingSingle] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDraggingSingle(true);
  };

  const handleDragLeaveSingle = (e) => {
    e.preventDefault();
    setDraggingSingle(false);
  };

  // const handleDropSingle = async (files, fieldName) => {
  //   const file = files?.[0];
  //   if (file) {
  //     const formData = new FormData();
  //     formData.append('image', file);
  //     await fileUploadFn(formData).then((fData) => {
  //       setValue(fieldName, fData?.data?.response?.url);
  //     });
  //   }
  // };

  const handleDropSingle = async (files, fieldName) => {
    const file = files?.[0];
    if (file) {
      // Validate file size
      const maxSizeInBytes = 10 * 1024 * 1024; // 5MB
      if (file.size > maxSizeInBytes) {
        toast.error('File size exceeds the maximum limit (10MB)');
        return;
      }

      // Validate file type
      const acceptedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
      if (!acceptedFileTypes.includes(file.type)) {
        toast.error('Invalid file type. Only JPG, JPEG, PNG, and WEBP files are allowed.');
        return;
      }

      const formData = new FormData();
      formData.append('image', file);

      try {
        const fData = await fileUploadFn(formData);
        setValue(fieldName, fData?.data?.response?.url);
      } catch (error) {
        toast.error('Error uploading file. Please try again later.');
      }
    }
  };



  // Example usage
  // handleDropSingle(filesArray, 'fieldName');


  const [showModal, setShowModal] = useState(false);
  const [deleteItem, setdeleteItem] = useState({});


  return (
    <>
      <Breadcrumb title='Create Product' pageTitle='Products' />
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Card>
          <Card.Header>
            <div className='d-flex'>
              <div className='flex-shrink-0 me-3'>
                <div className='avatar-sm'>
                  <div className='avatar-title rounded-circle bg-light text-primary fs-20'>
                    <i className='ri-file-info-line'></i>
                  </div>
                </div>
              </div>
              <div className='flex-grow-1 d-flex align-items-center'>
                <h5 className='card-title mb-1'>Product Size & Color</h5>
              </div>
            </div>
          </Card.Header>

          <Card.Body>
            <Row>
              <Col lg={5} className='mb-3'>
                <Form.Label htmlFor='product-title-input'>Product Size</Form.Label>
                <Select
                  isMulti
                  options={
                    activeSizes?.response?.map((it) => ({ value: it?.id, label: it?.name })) || []
                  }
                  placeholder='Select options'
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      border: '1px solid #ced4da', // Bootstrap-style border
                      borderRadius: '0.25rem', // Bootstrap-style border radius
                      boxShadow: 'none', // Remove box shadow
                      '&:hover': {
                        borderColor: '#ced4da', // Border color on hover
                      },
                    }),
                    multiValueLabel: (provided) => ({
                      ...provided,
                      color: '#fff', // Text color for selected options
                      backgroundColor: '#007bff', // Background color for selected options
                    }),
                    multiValueRemove: (provided) => ({
                      ...provided,
                      color: '#fff', // Remove button color for selected options
                      backgroundColor: '#007bff', // Background color for selected options
                      borderRadius: '0.25rem', // Bootstrap-style border radius
                      '&:hover': {
                        backgroundColor: '#0056b3', // Background color on hover
                      },
                    }),
                  }}
                  onChange={(e, val) => {
                    setValue(`sizes`, e, validateWith);
                    setValue(`sizesShowData`, e, validateWith);
                  }}
                  value={getValues('sizes')}
                />
              </Col>
              <Col lg={5} className='mb-3'>
                <Form.Label htmlFor='product-title-input'>Product Color</Form.Label>


                <Select
                  isMulti
                  options={
                    activeColors?.response?.map((it) => ({ value: it?.id, label: it?.name })) || []
                  }
                  placeholder='Select options'
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      border: '1px solid #ced4da', // Bootstrap-style border
                      borderRadius: '0.25rem', // Bootstrap-style border radius
                      boxShadow: 'none', // Remove box shadow
                      '&:hover': {
                        borderColor: '#ced4da', // Border color on hover
                      },
                    }),
                    multiValueLabel: (provided) => ({
                      ...provided,
                      color: '#fff', // Text color for selected options
                      backgroundColor: '#007bff', // Background color for selected options
                    }),
                    multiValueRemove: (provided) => ({
                      ...provided,
                      color: '#fff', // Remove button color for selected options
                      backgroundColor: '#007bff', // Background color for selected options
                      borderRadius: '0.25rem', // Bootstrap-style border radius
                      '&:hover': {
                        backgroundColor: '#0056b3', // Background color on hover
                      },
                    }),
                  }}
                  onChange={(e, val) => {
                    setValue(`colours`, e, validateWith);
                    setValue(`colorsShowData`, e, validateWith);
                  }}
                  value={getValues('colours')}
                />
              </Col>
              <Col lg={2} className='mb-3 my-auto'>
                <button
                  className='btn btn-secondary shadow-lg rounded ms-2'
                  type='button'
                  onClick={() => {
                    if (getValues('colours')?.length > 0 && getValues('sizes')?.length > 0) {
                      const otherData = {
                        productId: productId,
                        skuId: defaultDataSku,
                        quantity: 1,
                        maxOrderQuantity: 1,
                        MRP: defaultDataMRP,
                        sellingPrice: defaultDatasellingPrice,
                        offer: {},
                      };
                      const sizeColorData = generateProductSizeColourData(
                        getValues('sizes'),
                        getValues('colours'),
                        otherData,
                      );

                      const pdImges = getValues('colours').map((pd) => ({
                        productId: productId,
                        productColourId: pd,
                        image: [],
                      }));

                      setValue('productImageColourData', pdImges);
                      setValue('productSizeColourData', sizeColorData, validateWith);

                      setShowVarient(true);
                    }
                  }}
                >
                  Generate
                </button>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {showVarient &&
          getValues('colours')?.map((colorItems) => (
            <>
              <div className='product-devider'>
                <div className='product-variant-wrapper'>
                  <div className='choosen-product-variant'>
                    <span
                      class='choosen-color'
                      id='BlackVariant'
                      style={{ backgroundColor: colorName(colorItems)?.hexCode }}
                    ></span>
                    <p>{colorName(colorItems)?.name} Color Product Veriant</p>
                  </div>
                </div>
              </div>

              <Card>
                <Card.Header className='d-flex justify-content-between'>
                  <div className='d-flex'>
                    <div className='flex-shrink-0 me-3'>
                      <div className='avatar-sm'>
                        <div className='avatar-title rounded-circle bg-light text-primary fs-20'>
                          <i className='bi bi-images'></i>
                        </div>
                      </div>
                    </div>
                    <div className='flex-grow-1'>
                      <h5 className='card-title mb-1'>
                        Upload Product Image<span className='text-danger'>*</span>
                      </h5>
                      <p className='text-muted mb-0'>
                        For {colorName(colorItems)?.name} {getProducInfo?.productTitle}
                      </p>
                    </div>
                  </div>
                  <div className='d-flex'>
                    <Form>
                      <div key={`default-radio`} className='mb-3'>
                        <Form.Check // prettier-ignore
                          type='radio'
                          id={`default-radio`}
                          label={`List View: Images`}
                          onClick={() => setValue('isDefault', colorItems?.value)}
                          checked={getValues('isDefault') == colorItems?.value}
                        />
                      </div>
                    </Form>
                  </div>
                </Card.Header>
                <Card.Body>
                  <div>
                    <div className='dropzone dz-clickable text-center '>
                      <Dropzone
                        accept='image/*'
                        onDrop={(acceptedFiles) => {
                          handleAcceptedFiles(acceptedFiles, colorItems);
                        }}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div className='dz-message needsclick' {...getRootProps()}>
                            <input
                              className='mb-3 display-4 text-muted ri-upload-cloud-2-fill'
                              {...getInputProps()}
                            />
                            <h5 style={{ height: '249px' }}>Drop files here or click to upload.</h5>
                          </div>
                        )}
                      </Dropzone>
                    </div>

                    <div className='list-unstyled mb-0' id='file-previews'>
                      {selectedFiles
                        ?.filter((it) => it?.productColourId === colorItems?.value)
                        .map((f, i) => {
                          // const colorNameSingle = getValues(`${colorName(colorItems)?.name}`)
                          return (
                            <Card
                              className='mt-1 mb-0 shadow-none border dz-preview dz-processing dz-image-preview dz-success dz-image  dz-complete'
                              key={f?.preview}
                            >
                              <div className='p-2'>
                                <Row className='align-items-center'>
                                  <Col className='col-auto'>
                                    <div className='image d-flex'>
                                      <Form.Check
                                        className='mt-0 me-1 cursor-pointer'
                                        type='radio'
                                        checked={`${f?.default}` === 'true'}
                                        key={f?.preview}
                                        aria-label='Radio button for following text input'
                                        name={f?.preview}
                                        onChange={(e) => {
                                          // setValue(colorNameSingle, f?.preview, validateWith);

                                          setselectedFiles(
                                            selectedFiles?.map((it) =>
                                              it?.preview === f?.preview
                                                ? { ...it, default: true }
                                                : {
                                                  preview: it?.preview,
                                                  productColourId: it?.productColourId,
                                                  default:
                                                    it?.productColourId === f?.productColourId
                                                      ? false
                                                      : it?.default,
                                                },
                                            ),
                                          );
                                          //   dispatch(updateSelectedCategory(cat?.id));
                                          // updateSelectedCategory
                                        }}
                                      />
                                      <img
                                        // data-dz-thumbnail=""
                                        className='avatar-sm rounded bg-light'
                                        alt={f?.name}
                                        src={f?.preview}
                                      />

                                      <div
                                        onClick={() => {
                                          setdeleteItem(f);
                                          setShowModal(true);
                                        }}
                                        className='avatar-title rounded-circle bg-light text-primary fs-18 cursor-pointer ms-1'
                                      >
                                        <i class='ri-close-line'></i>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col>
                                    <Link to='#' className='text-muted font-weight-bold'>
                                      {f.name}
                                    </Link>
                                    <p className='mb-0'>
                                      <strong>{f.formattedSize}</strong>
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </Card>
                          );
                        })}
                    </div>
                  </div>
                  <div className='error-msg mt-1'>Please add a product images.</div>
                </Card.Body>
              </Card>

              <Card>
                <Card.Header>
                  <div className='d-flex'>
                    <div className='flex-shrink-0 me-3'>
                      <div className='avatar-sm'>
                        <div className='avatar-title rounded-circle bg-light text-primary fs-18'>
                          <i className='ri-stock-line'></i>
                        </div>
                      </div>
                    </div>
                    <div className='flex-grow-1'>
                      <h5 className='card-title mb-1'>Product Stock</h5>
                      <p className='text-muted mb-0'>
                        For {colorName(colorItems)?.name} {getProducInfo?.productTitle}
                      </p>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <div className='table-responsive mt-4 mt-xl-0'>
                    <Button onClick={() => handleShow(colorItems)}>Add more size</Button>
                    <Table className='table-primary table-striped table-nowrap align-middle mb-0 mt-3 rounded-3 overflow-hidden'>
                      <thead>
                        <tr>
                          <th scope='col'>Product Variant</th>
                          <th scope='col'>QTY</th>
                          <th scope='col'>Max QTY</th>

                          <th scope='col'>SKU Id</th>
                          <th scope='col'>(₹) MRP</th>
                          <th scope='col'>(₹) Selling Price</th>
                          <th scope='col'>Offer</th>
                          <th scope='col'>
                            <div className='d-flex justify-content-center'>Action</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filterSizeVarients(colorItems)?.map((sizeitem, index) => (
                          <tr>
                            <td>
                              <div className='choosen-product-variant'>
                                <span
                                  class='choosen-color border'
                                  id='BlackVariant'
                                  style={{ backgroundColor: colorName(colorItems)?.hexCode }}
                                ></span>

                                <p>
                                  Product Size : <span> {sizeName(sizeitem?.sizeId)?.name}</span>
                                </p>
                              </div>
                            </td>
                            <td>
                              <div>
                                <Form.Control
                                  type='number'
                                  id='product-title-input'
                                  defaultValue=''
                                  placeholder='0'
                                  required
                                  {...register(
                                    `productSizeColourData.${findIndexForChangeEvent(colorItems, sizeitem?.sizeId)}.quantity`,
                                    { valueAsNumber: true },
                                  )}
                                  value={sizeitem.quantity}
                                />
                              </div>
                            </td>
                            <td>
                              <div>
                                <Form.Control
                                  type='number'
                                  id='product-title-input'
                                  defaultValue=''
                                  placeholder='0'
                                  required
                                  {...register(
                                    `productSizeColourData.${findIndexForChangeEvent(colorItems, sizeitem?.sizeId)}.maxOrderQuantity`,
                                    { valueAsNumber: true },
                                  )}
                                  value={sizeitem.maxOrderQuantity}
                                />
                              </div>
                            </td>
                            <td>
                              <div>

                                <Form.Control
                                  type='text'
                                  id='product-title-input'
                                  defaultValue=''
                                  readOnly
                                  placeholder='0'
                                  required
                                  {...register(
                                    `productSizeColourData.${findIndexForChangeEvent(colorItems, sizeitem?.sizeId)}.skuId`,
                                  )}
                                />
                              </div>
                            </td>
                            <td>
                              <div>
                                {/* <Form.Control type="hidden" id="formAction" name="formAction" defaultValue="add" />
                                                                <Form.Control type="text" className="d-none" id="product-mrp-input" /> */}
                                <Form.Control
                                  type='text'
                                  id='product-title-input'
                                  name='MRP'
                                  readOnly
                                  defaultValue=''
                                  placeholder='0'
                                  required
                                  {...register(
                                    `productSizeColourData.${findIndexForChangeEvent(colorItems, sizeitem?.sizeId)}.MRP`,
                                  )}
                                  value={sizeitem.MRP}
                                />
                              </div>
                            </td>
                            <td>
                              <div>
                                {/* <Form.Control type="hidden" id="formAction" name="formAction" defaultValue="add" />
                                                                <Form.Control type="text" className="d-none" id="product-sellmrp-input" /> */}
                                <Form.Control
                                  type='text'
                                  id='product-title-input'
                                  name='sellingPrice'
                                  readOnly
                                  defaultValue=''
                                  placeholder='0'
                                  required
                                  value={sizeitem.sellingPrice}
                                  {...register(
                                    `productSizeColourData.${findIndexForChangeEvent(colorItems, sizeitem?.sizeId)}.sellingPrice`,
                                  )}
                                />
                              </div>
                            </td>
                            <td>
                              <Form.Select
                                className='form-select'
                                aria-label='.form-select-lg example'
                                onChange={(event) => {
                                  setValue(
                                    `productSizeColourData.${findIndexForChangeEvent(colorItems, sizeitem?.sizeId)}.offer`,
                                    event.target.value,
                                    validateWith,
                                  );
                                }}
                              >
                                <option selected>Offer</option>
                                <option value='Extra ₹200 Off'>Extra ₹200 Off</option>
                                <option value='Bank Offer 10%'>Bank Offer 10%</option>
                                <option value='₹500 On ICICI Bank'>₹500 On ICICI Bank </option>
                              </Form.Select>
                            </td>
                            <td>
                              <div className='d-flex justify-content-center'>
                                <Link
                                  to='#'
                                  className='link-danger fs-15'
                                  title='Remove variant'
                                  onClick={() => {
                                    filterSizeVarients(colorItems)?.length > 1 &&
                                      handleDeleteSizeColor(colorItems, sizeitem?.sizeId);
                                  }}
                                >
                                  <i className='ri-delete-bin-line'></i>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </>
          ))}

        <Card>
          <Card.Header>
            <div className='d-flex align-items-center'>
              <div className='flex-shrink-0 me-3'>
                <div className='avatar-sm'>
                  <div className='avatar-title rounded-circle bg-light text-primary fs-18'>
                    <i className='ri-stock-line'></i>
                  </div>
                </div>
              </div>
              <div className='flex-grow-1'>
                <h5 className='card-title mb-1'>Product Banner Image<span className='text-danger'>*</span></h5>
                {/* <p className="text-muted mb-0">For {colorName(colorItems)?.name} {getProducInfo?.productTitle}</p> */}
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='table-responsive mt-4 mt-xl-0'>
              <div
                className='dropzone dz-clickable text-center mb-5'
                style={{
                  backgroundImage: `url(${getValues('productBannerImage')})`,
                  objectFit: 'contain',
                  width: 'auto',
                  height: '100%',
                  backgroundRepeat: 'no-repeat',
                  textAlign: 'center',
                }}
              >
                <Dropzone
                  accept='image/*'
                  onDrop={(acceptedFiles) => {
                    handleDropSingle(acceptedFiles, 'productBannerImage');
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className='dz-message needsclick' {...getRootProps()}>
                      <input
                        className='mb-3 display-4 text-muted ri-upload-cloud-2-fill'
                        {...getInputProps()}
                      />
                      <h5 style={{ height: '249px' }}>Drop files here or click to upload.</h5>
                    </div>
                  )}
                </Dropzone>
              </div>
            </div>
          </Card.Body>
        </Card>

        <Container fluid>
          <div className='d-flex'>
            <div>
              <button
                className='btn btn-primary shadow-lg rounded'
                onClick={() => {
                  navigate(`/product-edit/${productId}`);
                  dispatch(setProductCurrentStep('STEP2'));
                }}
              >
                Previous
              </button>
            </div>
            <div className='ms-auto'>
              <button
                className='btn btn-info shadow-lg rounded'
                type='submit'
                onClick={() => {
                  setIsExit(true);
                }}
              >
                Draft & Exit
              </button>
              <button
                className='btn  btn-danger shadow-lg rounded ms-2'
                onClick={() => navigate('/products-list')}
              >
                Cancel
              </button>

              <button className='btn btn-secondary shadow-lg rounded ms-2' type='submit'>
                Next
              </button>
            </div>
          </div>
        </Container>
      </FormProvider>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {' '}
          <Row>
            <Col lg={12} className='mb-3'>
              <Form.Label htmlFor='product-title-input'>Product Size</Form.Label>

              <Select
                isMulti
                options={
                  activeSizes?.response?.map((it) => ({ value: it?.id, label: it?.name })) || []
                }
                placeholder='Select options'
                styles={{
                  control: (provided) => ({
                    ...provided,
                    border: '1px solid #ced4da', // Bootstrap-style border
                    borderRadius: '0.25rem', // Bootstrap-style border radius
                    boxShadow: 'none', // Remove box shadow
                    '&:hover': {
                      borderColor: '#ced4da', // Border color on hover
                    },
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: '#fff', // Text color for selected options
                    backgroundColor: '#007bff', // Background color for selected options
                  }),
                  multiValueRemove: (provided) => ({
                    ...provided,
                    color: '#fff', // Remove button color for selected options
                    backgroundColor: '#007bff', // Background color for selected options
                    borderRadius: '0.25rem', // Bootstrap-style border radius
                    '&:hover': {
                      backgroundColor: '#0056b3', // Background color on hover
                    },
                  }),
                }}
                onChange={(e, val) => {
                  setValue(`sizes`, e, validateWith);
                  setValue(`sizesShowData`, e, validateWith);
                }}
                value={getValues('sizes')}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
          <Button
            variant='primary'
            onClick={() => {
              const otherData = {
                productId: productId,
                quantity: 1,
                maxOrderQuantity: 1,
                MRP: defaultDataMRP,
                sellingPrice: defaultDatasellingPrice,
                offer: {},
              };
              const sizeColorData = generateProductSizeColourData(
                getValues(`sizesShowData`)?.map((it) => it?.value),
                [selectColorId],
                otherData,
              );

              const filterSizwess = filterSizeVarients(selectColorId)?.map(
                (it) => it?.sizeId?.value,
              );
              const filterdSizes = sizeColorData
                .filter((it) => {
                  return !filterSizwess.includes(it?.sizeId);
                })
                ?.map((it) => {
                  const sizeInfo = activeSizes?.response?.find((item) => item?.id == it?.sizeId);

                  return {
                    ...it,
                    sizeId: { ...sizeInfo, value: sizeInfo?.id, label: sizeInfo?.name },
                    skuId: `KH-TS${defaultDataSku}-${getAbbreviation(selectColorId?.label)}-${sizeInfo?.name}`,
                  };
                });

              append([...filterdSizes]);
              handleClose();
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <DeleteModal
        showModal={showModal}
        // loading={deleteLoading}
        setShowModal={setShowModal}
        data={deleteItem}
        handleSubmit={() => {
          const updateImages = getValues('productImageColourData').map((it) =>
            it?.productColourId?.value === deleteItem?.productColourId
              ? { ...it, image: it?.image?.filter((url) => url?.preview !== deleteItem?.preview) }
              : it,
          );
          setValue('productImageColourData', updateImages);

          setselectedFiles(selectedFiles?.filter((it) => it?.preview !== deleteItem?.preview));

          setShowModal(false);
          toast.success('Image removed successfully');
        }}
      />
    </>
  );
};

export default StepTwoProduct;
